export default "__VITE_ASSET__D4Y4fvwa__"